import { useState, useEffect } from 'react';
import { PagingQuery } from 'tea-component';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import usePagination from './usePagination';
import useSort from './useSort';
import useSearch from './useSearch';

import type { IStoreRankDetailsTablesSourceData } from '@/pages/intelligence/types/storeRank';

export default function useTables(option: {
  // 完成的列表数据，表格的分页、排序、搜索 都是基于这个完整的数据 进行计算的
  sourceData: IStoreRankDetailsTablesSourceData[];
  pageLogConfig?: any;
}) {
  const { sourceData: sourceDataOuter, pageLogConfig } = option || {};

  // 排序、分页后的数据（排序、分页 是基于 搜索后的数据 计算的）也是 表格展示的数据
  const [records, setRecords] = useState<IStoreRankDetailsTablesSourceData[]>([]);

  // 保存的排序的数据，因为翻页的时候 是要基于 排序后的结果 计算的
  const [sortedRecords, setSortedRecords] = useState<IStoreRankDetailsTablesSourceData[]>([]);

  const {
    // 分页相关
    pagination,
    setPagination,
    // 分页change的回调，包含翻页、修改页码
    onPaginationChange,
    // 获取分页计算后的数据，基于排序计算后的数据
    getRecordsByPagination,
  } = usePagination();

  const {
    // 排序相关
    sortInfo,
    // 排序change的回调
    onSortChange,
    // 获取排序后的数据，基于搜索计算后的数据
    getSortedRecords,
  } = useSort();

  const {
    // 搜索后的数据
    sourceData,
    // 搜搜关键字
    keywords,
    // 搜索输入框change的回调
    onChange,
    // 搜索的回调
    onSearch,
    // 搜索清空的回调
    onClear,
  } = useSearch({
    sourceData: sourceDataOuter,
    pageLogConfig,
  });

  const handleSearch = (payload?: string) => {
    onSearch(payload);
    setPagination({
      ...pagination,
      pageIndex: 1,
    });
  };

  const handlePaginationChange = (pagination: PagingQuery) => {
    const recordsTemp = getRecordsByPagination(sortedRecords, pagination);
    setRecords(recordsTemp);
    onPaginationChange(pagination);
  };

  const handleSortChange = (sortInfo: SortByItemType) => {
    const paginationTemp = {
      ...pagination,
      pageIndex: 1,
    };
    const sortedRecordsTemp = getSortedRecords(sourceData, sortInfo);
    const recordsTemp = getRecordsByPagination(sortedRecordsTemp, paginationTemp);
    onSortChange(sortInfo);
    onPaginationChange(paginationTemp);
    setRecords(recordsTemp);
    setSortedRecords(sortedRecordsTemp);
  };

  useEffect(() => {
    const sortedRecordsTemp = getSortedRecords(sourceData, sortInfo);
    const recordsTemp = getRecordsByPagination(sortedRecordsTemp, pagination);
    setRecords(recordsTemp);
    setSortedRecords(sortedRecordsTemp);
  }, [sourceData]);

  return {
    sourceData,
    records,
    pagination,
    handlePaginationChange,
    sortInfo,
    handleSortChange,
    keywords,
    onChange,
    onSearch: handleSearch,
    onClear,
  };
}
